import styles from './styles.module.css';

type RatingNumberProps = {
  maxRating: number;
  minRating: number;
  value: number;
  onChange: (value: number) => void;
}

const RatingNumber: React.FC<RatingNumberProps> = (props) => {
  const { maxRating, minRating, value, onChange } = props;
  const checkboxCount = maxRating - minRating + 1;
  return (
    <div className="flex flex-wrap gap-2">
      {Array.from({ length: checkboxCount }).map((_, index) => (
        <div 
          className={`${styles.ratingCheck} ${value === index + minRating ? styles.selected : ""}`}
          onClick={() => onChange(index + minRating)}
        >
          {index + minRating}
        </div>
      ))}
    </div>
  )
}

export default RatingNumber